module.exports = __webpack_public_path__ + "img/desktop_v2.94579099.svg";